import { useMemo } from 'react';

import {
  useListUserMeetingJoinsWithUsersQuery,
  UserMeetingJoinWhereInput,
} from '@/@generated/codegen/API';

import { FAKE_MEETING_ID } from './useCreateFakeMeetingUtils';
import { useEntitySubscription } from './useEntitySubscription';

export default function useUserMeetingJoins(meetingID: string | null | undefined) {
  const where: UserMeetingJoinWhereInput = useMemo(() => {
    return {
      meetingId: {
        equals: meetingID,
      },
    };
  }, [meetingID]);
  const userMeetingJoinsQuery = useListUserMeetingJoinsWithUsersQuery({
    variables: {
      paginationArgs: {
        first: 100,
      },
      where,
    },
    skip: !meetingID || meetingID === FAKE_MEETING_ID,
  });

  useEntitySubscription('UserMeetingJoin', {
    onCreate: {
      variables: {
        where: where,
      },
    },
    onDelete: {
      variables: {},
    },
  });

  return userMeetingJoinsQuery;
}
